module.exports = __webpack_public_path__ + "media/hero.bc9be808.mp4";